<template>
  <footer class="relative bg-blueGray-200 pt-8 pb-6">
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap text-center lg:text-left">
        <div class="w-full lg:w-6/12 px-4">
          <img
            class="h-12 w-12"
            src="/metis-assets/logos/metis/metis.webp"
            alt="localgps Logo"
          />
          <h5 class="text-sm mt-4 mb-2 w-full lg:w-72 text-blueGray-600">
            {{ footerDesc }}
          </h5>
          <div class="hidden mt-6 lg:mb-0 mb-6">
            <a v-for="(icon, index) in icons" :href="icon.link">
              <button
                :key="index"
                class="bg-white text-lightBlue-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
              >
                <span :class="icon.iconClass"></span>
              </button>
            </a>
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="flex flex-wrap items-top mb-6">
            <div
              v-for="(link, index) in navLinks"
              :key="index"
              class="w-full lg:w-4/12 px-4 ml-auto"
            >
              <span
                class="block uppercase text-blueGray-500 text-sm font-semibold mb-2"
              >
                {{ link.heading }}
              </span>
              <ul class="list-unstyled">
                <li v-for="(item, index) in link.links" :key="index">
                  <a
                    class="font-semibold block pb-2 text-sm"
                    :href="item.to"
                  >
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <hr class="my-6 border-blueGray-300" />
      <div
        class="flex flex-wrap items-center md:justify-between justify-center"
      >
        <div class="w-full md:w-4/12 px-4 mx-auto text-center">
          <div class="text-sm text-blueGray-500 font-semibold py-1">
            Copyright © {{ date }} {{ footerSiteName }}
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      date: new Date().getFullYear(),
      footerDesc: 'This website uses data from cqc.org.uk under the open government licence.',
      footerSiteName: 'Local GPS',
      navLinks: [
        /*{
          heading: "About Us",
          links: [
            { name: "Contact Us", to: "/contact-us/" },
            { name: "About Us", to: "/about/" },
          ],
        },*/
        {
          heading: "Resources",
          links: [
            { name: "Terms & Conditions", to: "/tos" },
            { name: "Privacy Policy", to: "/privacy" },
            { name: "Contact Us", to: "mailto:hello@localgps.co.uk" }
          ],
        },
      ]
    };
  },
};
</script>
